import { getCopyYear } from 'utils';

const LayoutV2Footer: React.FunctionComponent = function () {
  return (
    <div className="flex w-full px-4 py-6 mx-auto text-center md:py-12 max-w-256 text-14-22 text-neutral-600 md:mt-0">
      <p>
        {`© ${getCopyYear()} Ideal Sales Solutions Limited is a licensed credit broker and not a lender.
Ideal Sales Solutions Ltd is authorised and regulated by the Financial Conduct Authority. Firm Reference Number 703401. VAT Number GB975327880.
Registered in England with Companies House - Company Registration Number: 06724294 Registered with the ICO under registration number Z1790314.`}
      </p>
    </div>
  );
};

export default LayoutV2Footer;
